import { useState } from "react";
import { MoveHorizontal } from "lucide-react";

export default function BeforeAfterSlider({
  before,
  after,
  label,
  beforeLabel = "During works",
  afterLabel = "Finished",
  alt = "",
  aspect = "aspect-[3/4]",
}) {
  const [pos, setPos] = useState(50);

  const update = (clientX, el) => {
    const r = el.getBoundingClientRect();
    setPos(Math.min(97, Math.max(3, ((clientX - r.left) / r.width) * 100)));
  };

  return (
    <div data-testid="before-after-slider">
      <div
        className={`relative ${aspect} w-full cursor-ew-resize select-none overflow-hidden rounded-2xl border border-slate-200 shadow-[0_12px_36px_rgba(16,24,40,0.12)]`}
        onMouseDown={(e) => update(e.clientX, e.currentTarget)}
        onMouseMove={(e) => e.buttons === 1 && update(e.clientX, e.currentTarget)}
        onTouchMove={(e) => update(e.touches[0].clientX, e.currentTarget)}
      >
        <img src={after} alt={alt ? `${alt} - finished` : "Finished result"} className="absolute inset-0 h-full w-full object-cover" draggable="false" />
        <div className="absolute inset-y-0 left-0 overflow-hidden" style={{ width: `${pos}%` }}>
          <img
            src={before}
            alt={alt ? `${alt} - ${beforeLabel.toLowerCase()}` : "Work in progress"}
            className="absolute inset-0 h-full object-cover"
            style={{ width: `${(100 * 100) / Math.max(pos, 3)}%`, maxWidth: "none" }}
            draggable="false"
          />
        </div>

        <div className="absolute inset-y-0 w-1 bg-white shadow-[0_0_12px_rgba(0,0,0,0.35)]" style={{ left: `${pos}%` }}>
          <span className="absolute top-1/2 flex h-10 w-10 -translate-x-1/2 -translate-y-1/2 items-center justify-center rounded-full bg-brand-red text-white shadow-lg">
            <MoveHorizontal className="h-5 w-5" />
          </span>
        </div>

        <span className="absolute left-4 top-4 rounded-full bg-brand-ink/70 px-3 py-1 font-mono text-[10px] uppercase tracking-widest text-white backdrop-blur-md">
          {beforeLabel}
        </span>
        <span className="absolute right-4 top-4 rounded-full bg-brand-red px-3 py-1 font-mono text-[10px] uppercase tracking-widest text-white">
          {afterLabel}
        </span>
      </div>
      {label && <p className="mt-3 text-center font-mono text-xs uppercase tracking-[0.2em] text-slate-500">{label}</p>}
    </div>
  );
}
